import React from "react";
import LeftImg from './images/services/task-img.jpg'
import Icon01 from './images/services/task-1.png'
import Icon02 from './images/services/task-2.png'
import Icon03 from './images/services/task-3.png'
import Icon04 from './images/services/task-4.png'
import Icon05 from './images/services/task-5.png'
function CustomerInfo() {
  return (
    <section className="image-description-section section" style={{alignItems:"start"}}>
        <p className="section-heading">Easily track and manage all your issues, tasks and software bugs.</p>
    <div className="image-description-left image-section-left">
        <img src={LeftImg} alt="Description Image" className="image_description image-width"
        style={{filter:'invert(0)'}}
        />
    </div>
    <div className="image-description-right description">
        <h2 className="heading-underline">Key Features</h2>
        <p className="description-para">
            <img src={Icon01} width={30} height={30} className="img-fluid" alt="icons"/>
           Task management & tracking system.</p>
        <p className="description-para">
            <img src={Icon02} width={30} height={30} className="img-fluid" alt="icons"/>
            Project management tool. </p>
        <p className="description-para">
            <img src={Icon03} width={30} height={30} className="img-fluid" alt="icons"/>
            Software bug tracking. </p>
        <p className="description-para">
            <img src={Icon04} width={30} height={30} className="img-fluid" alt="icons"/>
            Software test-case management.</p>
        <p className="description-para">
            <img src={Icon05} width={30} height={30} className="img-fluid" alt="icons"/>
            Detailed reports and dashboard.</p>
    </div>
</section>  
  )
}
export default CustomerInfo;